import {Avatar, AvatarGroup, Box} from "@mui/material";
import Typography from "@mui/material/Typography";
import {useEffect} from "react";
import isEmpty from "lodash/isEmpty";
import RcGantt from "rc-gantt";
import {TaskTreeVO, useQueryTaskTree} from "@/service/task.s";
import {str2arr, stringAvatar} from "@/helper/method";
import * as React from "react";

export type DependenceType = {
    from: number;
    to: number;
    type: 'start_finish' | 'finish_start' | 'start_start' | 'finish_finish';
    color?: string;
}

export const GanttChart = () => {
    const {mutate: queryTaskTreeMutate, data: taskTreeData} = useQueryTaskTree()
    const taskTree = taskTreeData?.data || [] as TaskTreeVO[]

    useEffect(() => {
        queryTaskTreeMutate({keyword: ""})
    }, []);

    const getDependence = (trees: TaskTreeVO[], result: DependenceType[] = [], parentId?: number): DependenceType[] => {
        trees.forEach((node: TaskTreeVO) => {
            if (node.parentId == parentId) {
                const newNode: DependenceType = {from: parentId, to: node.id, type: "start_start"}; // 复制节点并添加parentId
                result.push(newNode); // 将节点添加到结果中
            }
            if (!isEmpty(node.children)) {
                getDependence(node.children, result, node.id); // 递归处理子节点
            }
        });
        return result;
    }

    return <Box sx={(theme) => ({
        width: "100%",
        maxWidth: {sm: "100%", md: "1700px"},
        height: "calc(100vh - 186px)", "& .gantt-task-bar-label": {mt: '-12px'},
        "& .gantt-body": {
            borderRadius: '12px', "& header": {
                backgroundColor: theme.palette.background.paper,
                borderTopLeftRadius: '12px', borderTopRightRadius: '12px'
            }, "& .gantt-trigger": {
                backgroundColor: theme.palette.background.paper, borderTopRightRadius: '12px'
            }
        }
    })}> <RcGantt<TaskTreeVO>
        data={taskTree}
        tableIndent={16}
        disabled={true}
        rowHeight={58}
        alwaysShowTaskBar={true}
        renderBar={({record}, {width}) => {
            return <Box component={'div'} alignItems={'center'} alignContent={'center'} sx={{
                width, height: 26, backgroundColor: '#dbdbdb', borderRadius: '3px', mt: '-8px'
            }}>
                <Typography position={'absolute'} top={'50%'} bottom={'50%'} color={'textSecondary'} pl={1} variant={'subtitle2'}
                            fontSize={12}>{record.taskName}</Typography>
                <Box alignContent={'center'} component={'div'}
                     sx={{width: `${record.ratio}%`, height: '100%', pt: '2px', borderRadius: '3px', backgroundColor: 'rgb(250, 196, 101)'}}>
                </Box>

            </Box>
        }}
        dependencies={getDependence(taskTree) as any}
        columns={[
            {
                name: "taskName",
                label: "任务名称",
                minWidth: 120,
                maxWidth: 220,
            },
            {
                name: "executors",
                label: "执行人",
                width: 90,
                maxWidth: 90,
                align: 'left',
                render: (record) => {
                    const newExecutors: string[] = str2arr(record.executors, 'string')
                    return <Box display="flex" justifyContent="space-between" alignItems="center">
                        <AvatarGroup sx={{
                            '& .MuiAvatarGroup-avatar': {
                                width: 26, height: 26, fontSize: 8, border: 'none'
                            }
                        }} max={3}>
                            {newExecutors?.map((owner: string, index: number) => <Avatar key={index} {...stringAvatar(owner)} />)}
                        </AvatarGroup></Box>
                }
            },
            {
                name: "startDate",
                label: "开始时间",
                width: 100,
            },
            {
                name: "endDate",
                label: "结束时间",
                width: 100,
            },
            // {
            //     name: "planName",
            //     label: "目标计划",
            //     width: 120,
            // }
        ]}
        onUpdate={async () => true}
    />
    </Box>
}